// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { DigitalPaymentV1ClientGeneratedBankAccountDetail } from './digitalPaymentV1ClientGeneratedBankAccountDetail.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DigitalPaymentV1ClientGeneratedExternalAccountDetail {
    'bankAccount'?: DigitalPaymentV1ClientGeneratedBankAccountDetail | null;
    'externalAccountAliasId'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DigitalPaymentV1ClientGeneratedExternalAccountDetail>> = [
        {
            "name":     "bankAccount",
            "baseName": "bankAccount",
            "type":     "DigitalPaymentV1ClientGeneratedBankAccountDetail"
        },
        {
            "name":     "externalAccountAliasId",
            "baseName": "externalAccountAliasId",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return DigitalPaymentV1ClientGeneratedExternalAccountDetail.attributeTypeMap;
    }
}
